export const PRODUCT_FAMILY = {
  NORMAL_MEAL: 'normal-meal',
  MERCH: 'merch',
  CUSTOMIZABLE_MEAL: 'customizable-meal',
};
